import React, { useState, useEffect } from "react";
import { Box } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { defaultMarks, calcRiskIndex, gridForComputedIndex, gridForHazard } from "./CystellarDetailUtils";
import { tableCellRender } from "../../util/tableUtils";

export const CystellarNaturalEventsDetails = ({ selectedProperties: selectedProp }) => {
  const { t } = useTranslation();
  const nationalAverageValue = 39.08; // this will be place on every item in the geojson file
  const [selectedProperties, setSelectedProperties] = useState(selectedProp);
  const [nationalPercentileMarks, setNationalPercentileMarks] = useState(defaultMarks);
  const nationalAverageMarks = [
    ...defaultMarks,
    { value: nationalAverageValue, label: nationalAverageValue },
  ];
  const [riskScore, setRiskScoreValue] = useState(0);
  const [riskIndexText, setRiskIndexText] = useState("");

  useEffect(() => {
    const currRiskIndex = selectedProp?.cys_rindx_ITA_PC_NE;
    if (currRiskIndex) {
      setRiskIndexText(calcRiskIndex(t, currRiskIndex));
      setRiskScoreValue(currRiskIndex);
      setNationalPercentileMarks([
        ...defaultMarks,
        {
          value: currRiskIndex,
          label: tableCellRender(currRiskIndex),
        },
      ]);
    }
    setSelectedProperties(selectedProp);
  }, [selectedProp, t]);

  return (
    <Box m={2} mb={5}>
      {gridForComputedIndex(
        t,
        selectedProperties,
        riskScore,
        riskIndexText,
        nationalAverageValue,
        nationalAverageMarks,
        nationalPercentileMarks,
        t("climateIndex.CysNe"),
      )}
      {gridForHazard(
        t,
        t("climateIndex.highWind"),
        selectedProperties?.windstorm_severe_c_norm,
        selectedProperties?.windstorm_severe_c,
        selectedProperties?.windstorm_severe_c_w,
      )}
      {gridForHazard(
        t,
        t("climateIndex.hail"),
        selectedProperties?.hail_large_c_norm,
        selectedProperties?.hail_large_c,
        selectedProperties?.hail_large_c_w,
      )}
    </Box>
  );
};
